/* eslint-disable max-len */
const StarIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox='0 0 24 24' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M12 0L13.1055 8.23495L18.4877 1.90496L14.9656 9.43033L22.9156 7.01502L15.8841 11.4416L23.8779 13.7078L15.5694 13.6301L21.069 19.8583L14.1215 15.3011L15.3808 23.5139L12 15.924L8.61921 23.5139L9.87853 15.3011L2.93101 19.8583L8.4306 13.6301L0.122143 13.7078L8.11594 11.4416L1.08442 7.01502L9.03444 9.43033L5.51231 1.90496L10.8945 8.23495L12 0Z'
      fill='currentColor'
    />
  </svg>
);

export { StarIcon };
